import { CookiesDetails } from "@nju/feature-portal-documents";
import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function CookiesPage() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent spacing="l">
        <CookiesDetails />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
